(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('grammarForPrefix', function () {
        var vowels = 'aeiouy';
        return {
            addAnOrA: function (str) {
                if (!str || !_(str).isString()) {
                    return '';
                }
                var firstChar = str.trim().charAt(0).toLowerCase();
                if (vowels.indexOf(firstChar) !== -1) {
                    return 'an ' + str;
                }
                return 'a ' + str;
            }
        };
    });
}());